/**
 * @param {{label: String, value: Number, backgroundColor: String}[]} dataArray
 */
export const convertToStackedBarChart = (dataArray) => ({
    labels: [""],
    datasets: dataArray.map(dataset => ({
        label: dataset.label,
        data: [dataset.value],
        backgroundColor: dataset.backgroundColor,
        stack: dataset?.stack ? dataset.stack : "",
    })),
})

export const convertToVerlaufStackedBarChart = (dataArray) => {
    const labels = [...new Set(dataArray.map(entry => entry.stack))]

    const datasets = dataArray.reduce((acc, entry) => {
        const dataset = acc.find(ds => ds.label === entry.label)

        dataset
            ? dataset.data.push(entry.value)
            : acc.push({
                label: entry.label,
                data: [entry.value],
                backgroundColor: entry.backgroundColor,
                stack: entry.stack.toString(),
            })

        return acc
    }, [])

    return {
        labels: labels,
        datasets: datasets,
    }
}

/**
 * @param {{label: String, value: Number, backgroundColor: String}[]} dataArray
 */
export const convertToPieOrParallelBarChart = (dataArray) => ({
    labels: dataArray.map(({label}) => label),
    datasets: [{
        data: dataArray.map(({value}) => value),
        backgroundColor: dataArray.map(({backgroundColor}) => backgroundColor),
    }],
})

/**
 * @param {{label: String, value: Number, backgroundColor: String}[]} dataArray
 */
export const convertToDonutChart = (dataArray) => ({
    labels: dataArray.map(({label}) => label),
    datasets: [{
        data: dataArray.map(({value}) => value),
        backgroundColor: dataArray.map(({backgroundColor}) => backgroundColor),
        spacing: 4,
    }],
})
